<div class="custom-accordion my-2">
  <div class="header px-4 py-3 mx-auto" (click)="opened = !opened">
    <div class="row">
      <div class="col-10">
        {{ title }}
      </div>
      <div class="col-2 text-right">
        <i
          class="fas "
          [class.fa-chevron-down]="!opened"
          [class.fa-chevron-up]="opened"
        ></i>
      </div>
    </div>
  </div>
  <div class="body mx-auto" [class.show]="opened">
    <ng-content></ng-content>
  </div>
</div>
